<template>
  <div>
    <el-dialog :visible="visible" title="选择分析的活动对象" width="1200px" :before-close="handleClose">
      <div class="search-box">
        <el-form ref="formSearch" :inline="true" :model="form" label-width="120px">
          <el-form-item label="营销类型:">
            <el-select size="small" v-model="form.dataFrom" style="width: 280px">
              <el-option
                v-for="(item, index) in dataFromList"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次类:">
            <el-select size="small" v-model="form.batchType " style="width: 280px">
              <el-option
                v-for="(item, index) in batchTypeList"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动主题:">
            <el-input style="width:280px" v-model="form.smsTitle" placeholder="请输入活动主题"></el-input>
          </el-form-item>
          <el-form-item label="发送时间:">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.sendTimeStart"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 126px;font-size:12px;"
                class="time1"
                :clearable="false"
                @change="moneyPayTimeChange"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.sendTimeEnd"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px;font-size:12px"
                class="time2"
                :clearable="false"
                @change="moneyPayTimeChange"
              ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
          </el-form-item>

          <div class="button-group">
            <el-button size="small" class="search" @click="submitForm('formSearch')">
              <i
                class="el-icon-search"
                style="display:inline-block;width:14px;height:12px"
              ></i> 查询
            </el-button>
            <el-button size="small" class="reset" @click="resetForm">重置</el-button>
          </div>
        </el-form>
        <div>
          <div class="left-table">
            <div class="table-box">
              <el-table
                ref="checkTable"
                :data="tableData"
                v-loading="tableLoading"
                height="250"
                @selection-change="handleSelectionChange"
                tooltip-effect="light"
                row-key="bid"
                style="width: 100%; border: 1px solid #eee"
              >
                <el-table-column type="selection" reserve-selection></el-table-column>
                <el-table-column label="活动主题" prop="smsTitle" width="250px"></el-table-column>
                <el-table-column label="短信内容" prop="content">
                  <template slot="header" slot-scope="scope">
                    <span>短信内容</span>
                    <span style="color:#7f85e9" @click="allShow = true" v-if="!allShow">（展开全部）</span>
                    <span style="color:#7f85e9" @click="allShow = false" v-else>（收起全部）</span>
                  </template>
                  <template slot-scope="scope">
                    <div class="hoveTitle" v-if="!allShow">{{scope.row.content}}</div>
                    <div v-else>{{scope.row.content}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="有效号码" prop="validCount"></el-table-column>
              </el-table>
              <!-- 分页器 -->
              <div class="pagination-box">
                <el-pagination
                  background
                  style="text-align: center; margin-top: 20px;"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="form.current"
                  :page-sizes="[10, 20, 30, 50, 100, 500]"
                  :page-size="form.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div class="right-table">
            <div class="title-line">
              <span>已选择</span>
              <span :style="{'color': globalBG}">（{{selectList.length}}个）</span>
              <span class="clear-btn" @click="clearAll">全部清空</span>
            </div>
            <div class="table-box">
              <div class="table-item" v-for="(item, index) in selectList" :key="index">
                <span>{{item.smsTitle}}</span>
                <i :style="{'color': globalBG}" class="del el-icon-error" @click="removeName(item)"></i>
              </div>
            </div>
            <!-- <div class="pagination-box">
              <el-pagination
                background
                style="text-align: center; margin-top: 20px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.current"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="form.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div> -->
          </div>
        </div>
        <div class="footer-bar">
          <span>请输入分析任务名称：</span>
          <el-input placeholder="不能重复，限50字" v-model="taskName" style="width:506px"></el-input>
          <div class="footer-btn">
             <el-button size="small" class="quxiao_button" @click="handleClose">取消</el-button>
             <el-button size="small" type="primary" @click="handleAddTask">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {batchList, insertTask} from "@/api/marketing/batchListSummary"
export default {
  /** 分析短信任务弹窗 */
  name: "analyze-sms-task",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  data() {
    return {
      // visible: true,
      allShow: false, // 是否全部显示
      form: {
        smsTitle: '',
        dataFrom: '',
        sendTimeEnd: '',
        sendTimeStart: '',
        batchType: 1,
        size: 10,
        current: 1
      },
      dataFromList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "短信测试",
          value: 0
        },  
        {
          label: "会员发送",
          value: 1
        },
        {
          label: "订单发送",
          value: 2
        },
        {
          label: "输入号码发送",
          value: 4
        },
        {
          label: "指定号码发送",
          value: 5
        },
        {
          label: "变量短信发送",
          value: 6
        },
        {
          label: "手动催评",
          value: 7
        },
        {
          label: "手动回评",
          value: 8
        },
        {
          label: "手动审核退款",
          value: 9
        },
         {
          label: "营销汇总分析发送",
          value: 10
        }
      ],
      batchTypeList: [
        {
          label: '官方发送',
          value: 1
        },
        {
          label: '自有通道发送 ',
          value: 2
        }
      ],
      tableData: [],
      total: 0,
      tableLoading: false,
      selectList: [],  // 选中的列表数据
      taskName: '',    // 任务名称
    };
  },
  mounted() {
    this.submitForm();
  },
  methods: {
    // 添加任务
    handleAddTask() {
      if (!this.selectList || this.selectList.length < 1) {
        this.$message.warning('请勾选列表！')
        return;
      }

      var dataList = [];
      this.selectList.forEach(item => {
        var temp = {
          batchId: item.bid,
          batchType: item.batchType
        }
        dataList.push(temp)
      })
      var param = {
        taskName: this.taskName,
        dataList
      };
      this.handleClose();
      insertTask(param).then(res => {
        if (res.code == '1') {
          this.$message.success('添加任务成功！')
        }else {
          this.$message.error(res.message);
        }
      })
    },
    handleClose() {
      this.$emit('onClose')
    },

    clearAll() {
      this.$refs.checkTable.clearSelection();
    },
    removeName(item) {
      const arr = this.tableData.filter(sub => { return sub.bid === item.bid }) // 取消当前表格里的选中状态时,用表格里的数据
      const row = arr.length ? arr[0] : item;
      // console.log('arr',arr, 'row', row);
      this.$refs.checkTable && this.$refs.checkTable.toggleRowSelection(row, false)
    },
    // 勾选内容
    handleSelectionChange(list) {
       console.log(list)
      this.selectList = list;
    },
    clearTime() {
      this.form.sendTimeStart  = '';
      this.form.sendTimeEnd  = '';
    },
    moneyPayTimeChange() {},
    submitForm() {
      this.tableLoading = true;
      batchList(this.form).then(res => {
        this.tableLoading = false;
        if (res.code == '1') {
          this.tableData = res.data.records;
          this.total = +res.data.total;
        }else {
          this.$message.error(res.message)
        }
      })
    },
    resetForm() {
      this.form = {
        smsTitle: '',
        dataFrom: '',
        sendTimeEnd: '',
        sendTimeStart: '',
        batchType: 1,
        size: 10,
        current: 1
      }
      this.submitForm();
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.submitForm();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.submitForm();
    },
  },
};
</script>

<style lang="scss" scoped>
.table-box{
  max-height: 400px;
  overflow: auto;
}
.search-box {
  .el-input,
  .el-select {
    width: 136px;
  }
  .button-group {
    text-align: center;
    // display: inline-block;
    margin-bottom: 20px;
    .search{
      width: 98px;
      height: 32px;
      color: #fe4d45;
      border: 1px solid #fe4d45 ;
      background-color: #fff;
   &:hover{
      color: #fff ;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
}.reset{
      width: 98px;
      height: 32px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
}
  }
}
.pagination-box {
}
.left-table {
  display: inline-block;
  width: 660px;
  vertical-align: text-top;
}
.right-table {
  display: inline-block;
  vertical-align: text-top;
  width: 450px;
  font-size: 14px;
  margin-left: 30px;
  color: #333333;
  border: 1px solid rgba(243, 243, 243, 1);
  .title-line {
    line-height: 40px;
    padding-left: 20px;
    box-shadow: -1px 2px 4px rgba(0, 0, 0, 0.04);
    position: relative;
    .clear-btn {
      position: absolute;
      right: 10px;
      cursor: pointer;
      color:#7f85e9 ;
      &:hover{
        color:#FE4D45 ;
      }
    }
  }
  .table-box {
     max-height: 350px;
    .table-item {
      padding: 20px;
      border-bottom: 1px solid #f3f3f3;
      position: relative;
      .del {
        width: 16px;
        height: 16px;
        font-size: 16px;
        position: absolute;
        right: 12px;
        cursor: pointer;
      }
    }
  }
}
.footer-bar{
  position: relative;
  margin-top: 20px;
  .quxiao_button{
      width: 98px;
      height: 32px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
}
  .footer-btn{
    position: absolute;
    right: 20px;
    top: 0;
  }
}
</style>
